import React from 'react';
import classnames from 'classnames';
import Button from '@/components/ui/Buttons/Button';
import Divider from '@/components/ui/Divider';
import { Theme } from '@/styles/darkMode';
import { RootState } from '@/redux/store';
import { useSelector } from 'react-redux';
import { useDarkModeContext } from '@/components/ui/PDP/DarkModeContext/useDarkModeContext';

export const StaticHeaderFallback = React.memo(function StaticHeaderFallback({
  isMobile
}: {
  isMobile?: boolean;
}) {
  const HELP_CENTER_URL = import.meta.env.VITE_HELP_CENTER_URL ?? 'https://help.pli.edu/s/';
  const stickyHeader = useSelector((state: RootState) => state.page.stickyHeader);

  const darkmodeContext = useDarkModeContext();
  const isDarkMode = darkmodeContext?.isDarkMode ?? false;
  const headerClasses = classnames(
    'sticky top-0 z-sticky-header transition-all',
    {
      'bg-transparent': !stickyHeader.isSticky && !isDarkMode,
      'bg-white': stickyHeader.isSticky,
      'bg-black': stickyHeader.isSticky || isDarkMode
    },
    {
      'top-[-165px] md:top-[-100px]': !stickyHeader.isSticky
    }
  );

  return (
    <>
      <header className={headerClasses} data-id="header">
        <div className="container relative flex items-center justify-between py-4 md:py-5">
          {/* Logo section */}
          <div className="flex items-center">
            <a
              href="/"
              aria-label="Go to home"
              className="block basis-[50px] focus:outline-none focus-visible:ring-2 md:basis-[66px]"
            >
              <img
                src="/logo-red.svg"
                alt="PLI Logo"
                className={isMobile ? 'h-6' : 'h-8'}
                width={isMobile ? 32 : 64}
                height={isMobile ? 16 : 32}
              />
            </a>
          </div>

          {/* Help center link */}
          <div>
            <Button
              label="Help center"
              ariaLabel="Open Help center in a new tab"
              color="white"
              size={isMobile ? 'small' : 'large'}
              className={classnames(
                'flex cursor-pointer items-center px-0 font-bold text-black hover:underline',
                {
                  'leading-[16px] text-[12px]': isMobile,
                  'leading-[20px] text-[14px]': !isMobile
                }
              )}
              style={{ fontFamily: 'Helvetica Neue', fontStyle: 'normal' }}
              iconRight="link-out"
              href={HELP_CENTER_URL}
              target="_blank"
              rel="noopener noreferrer"
            />
          </div>
        </div>

        <Divider color={Theme.Light} className="bg-silver" />
      </header>
    </>
  );
});
